import { defaultProps } from 'recompose';

import AutocompleteMultiple from '@/components/AutocompleteMultiple';

import categories from './categories';

export default defaultProps({ options: categories })(AutocompleteMultiple);
